import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import container from '../../helpers/container'
import config from '../../config'
import {
  BenchmarkGrid,
} from '../../components'
import Styles from './IndexFunds.css'


@CSSModules(Styles)
export default class IndexFunds extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Index Funds'
    const url = config.domain + config.routes.indexfunds
    //
    return (
      <div styleName='page'>
        {container.helmet(title, '', url)}
        <BenchmarkGrid />
      </div>
    )
  }
}
